module.exports = __webpack_public_path__ + "img/andrewmound.12030d65.jpg";